'use strict';

require('../../style/index.css');

require('./index.css');


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/button/style/css.js
// module id = 27
// module chunks = 0